export default new class Likes {
  constructor() {
    this.likeBtn = document.querySelectorAll('.like-btn');
    this.rating = document.querySelectorAll('.like-result');
    this.confirmBtn = document.querySelectorAll('.confirm-btn');
    this.likeCount = document.querySelectorAll('.like-count');
    this.dataAttr = 0;

    if (this.likeBtn) this.initBind();
  }

  initBind() {
    this.likeBtn.forEach((elem) =>  {
      elem.childNodes.forEach(btnEv =>  {
        if (btnEv.classList.contains('like-btn__child')) {
          btnEv.addEventListener('click',  (e) => {
            e.preventDefault();
            this.dataAttr = e.target.getAttribute('data-rating');
            if (this.dataAttr > 0) {
              this.likeBtn.forEach((elem) =>  {
                elem.childNodes.forEach(chElem => {
                  if (chElem.classList.contains('like-btn__child')) {
                  chElem.classList.remove('colored');
                  }
                })

              elem.childNodes.forEach(btn => {
                if(btn.classList.contains('like-btn__child')) {
                  e.preventDefault();
                  if (btn.getAttribute('data-rating') <= this.dataAttr) {
                    btn.classList.add('colored');
                  }
                }
              })
              })
              this.confirmBtn.forEach(btnEv => btnEv.addEventListener('click', (e) => {
                e.preventDefault();
                this.sendRequest(e);
              }))
            }
          })
        }
      })
    })
  }

  sendRequest(e) {
    let articleId = e.target.dataset.id;
    $.request('ArticleMarks::onSendLike', {
      data: {
        articleId:articleId,
        mark:this.dataAttr,
      },

      complete: (response) => {
        if (response.responseJSON.status === true)  {
          this.like(response.responseJSON);
        }
      },
    });
  }

  like(response) {
      this.likeBtn.forEach(elem => {
        elem.classList.add('hidden');
      })
      this.rating.forEach(elem => {
        elem.classList.remove('hidden');
      })
      this.likeCount.forEach(elem => {
        elem.innerText = response.count;
      })
      document.querySelector('.like-agitation').innerText = "Спасибо за оценку!";
  }
}()





